// Event Tracking
function gtmEvent($event = '', $parameters = {}) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer === 'object' && $event !== '') {

        var $push = {};
        if ($event) {
            $push = {...$push, 'event': $event};
        }

        var $layer = {...$push, ...$parameters}
        window.dataLayer.push($layer);
    }
}

window.gtmEvent = gtmEvent;